export const MIME_IMAGEs = {
  path: "https://resources.businessdraft.com/file-mime-image-v2.png",
  width: 250,
  height: 212,
  alt: "Image File Type",
};

export const MIME_PDF = {
  path: "https://resources.businessdraft.com/file-mime-pdf.png",
  width: 250,
  height: 212,
  alt: "PDF File Type",
};

export const MIME_DOCUMENT = {
  path: "https://resources.businessdraft.com/file-mime-document.png",
  width: 250,
  height: 212,
  alt: "Document or Text File Type",
};

export const MIME_UNKNOWN = {
  path: "https://resources.businessdraft.com/file-mime-unknown.png",
  width: 250,
  height: 212,
  alt: "Unknown File Type",
};

export const MIME_ALL = {
  path: "https://resources.businessdraft.com/file-mime-all.png",
  width: 250,
  height: 212,
  alt: "All File Types",
};

export const getMimeImage = (mimeOrMimes) => {
  const allowImage = mimeOrMimes.includes("image");
  const allowPdf = mimeOrMimes.includes("pdf");
  const allowDocument = mimeOrMimes.includes("document") || mimeOrMimes.includes("text") || mimeOrMimes.includes("application");

  if (
    allowImage &&
    allowPdf &&
    allowDocument
  ) return MIME_ALL;

  if (allowImage) return MIME_IMAGEs;
  if (allowPdf) return MIME_PDF;
  if (allowDocument) return MIME_DOCUMENT;

  return MIME_UNKNOWN;
};
